import Route from '@/classes/route';

export const routes: Route[] = [
  new Route({ name: 'about' }),
  new Route({ name: 'projects' }),
  new Route({ name: 'contact' }),
];
